<template>
  <b-nav-item @click="onLogout" class="rounded-pill">
    <font-awesome-icon
      :icon="['fa', 'sign-out-alt']"
      class="text-white pt-1 exitButton"
    />

    <b-modal ref="logoutModal" title="Выход из системы" @ok="onLogoutOK">
      <p>Вы уверены, что хотите выйти из системы?</p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary"> ОК </b-button>
        <b-button @click="cancel()"> Отмена </b-button>
      </template>
    </b-modal>
  </b-nav-item>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'
import { mobileWidthMapper } from '@/store/modules/mobileWidth'

const Mappers = Vue.extend({
  computed: {
    ...mobileWidthMapper.mapGetters(['isMobile'])
  }
})

@Component
export default class Logout extends Mappers {
  public $refs!: {
    logoutModal: BModal
  }

  private onLogout() {
    this.$refs.logoutModal.show()
  }

  private onLogoutOK() {
    this.$router.push('/logout')
  }
}
</script>

<style scoped>
.exitButton {
  font-size: 1.3em;
}
</style>
